import { get } from '@/utils/api';
import { routes } from '@/constants/routes';
import { FULL_ACCESS_ROLE_ID, LIMITED_USER_ALLOWED_ROUTE_NAMES } from '@/constants/access';

const state = {
  settings: null,
  settingsLoaded: false,
};

const getters = {
  roleId: (s) => (s.settings && s.settings.role_id != null ? Number(s.settings.role_id) : null),
  isFullAccess: (s, g) => g.roleId === FULL_ACCESS_ROLE_ID,
  displayName: (s) => {
    if (!s.settings) return '';
    return s.settings.name || s.settings.user_name || '';
  },
  profileImagePath: (s) => (s.settings && s.settings.profile_img) || '',
  isRouteAllowed: (s, g) => (routeName) => {
    if (g.isFullAccess) return true;
    if (!routeName) return false;
    return LIMITED_USER_ALLOWED_ROUTE_NAMES.has(routeName);
  },
};

const mutations = {
  SET_SETTINGS(state, data) {
    state.settings = data;
    state.settingsLoaded = true;
  },
  RESET_USER(state) {
    state.settings = null;
    state.settingsLoaded = false;
  },
};

const actions = {
  async ensureSettings({ state, commit, dispatch }) {
    if (state.settingsLoaded) return;
    await dispatch('fetchSettings');
  },

  async fetchSettings({ commit, dispatch }) {
    const response = await get(routes.Settings, {}, false);
    if (response.status !== 200 || !response.data?.success) {
      throw new Error(response.data?.message || 'Settings request failed');
    }
    const data = response.data.data;
    commit('SET_SETTINGS', data);
    const fullAccess = Number(data.role_id) === FULL_ACCESS_ROLE_ID;
    dispatch('menu/applyMenuAccess', fullAccess, { root: true });
  },

  reset({ commit, dispatch }) {
    commit('RESET_USER');
    dispatch('menu/applyMenuAccess', true, { root: true });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
